import { createForm } from '@seek/forms-ui';

import type { UserRegistrationType } from 'src/types/userRegistrationType';

export interface OnboardingFormData {
  firstName: string;
  lastName: string;
  userRegistrationType: UserRegistrationType;
  businessName?: string;
  abn?: string;
  phoneNumber?: string;
  phoneCountryCode?: string;
  emailOptIn?: boolean;
}

export const { FormProvider, useField } =
  createForm<OnboardingFormData>('onboardingForm');

export const mapImAToUserRegistrationType = (
  imA: string,
): UserRegistrationType => {
  switch (imA) {
    case 'private-seller':
      return 'PrivateSeller';
    case 'broker':
      return 'Broker';
    case 'franchisor':
      return 'Franchisor';
  }
  return 'Buyer';
};

export const isEmailConsentRequired = (userType: UserRegistrationType) =>
  userType === 'Broker' ||
  userType === 'Franchisor' ||
  userType === 'LicensorOrDistributor' ||
  userType === 'RealEstateAgent';
